const URL_BASE=process.env.REACT_APP_API;

export const URL_AGREEMENT_COMMERCIAL_LIST=`${URL_BASE}/agreement/commercial`;

//https://hmyadminbackprod.ddns.net/api/agreement/commercial